import React from 'react';
import WebPlayer from './WebPlayer.jsx';
import './WebPlayer.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeart, faHeartCrack, faVolumeLow } from '@fortawesome/free-solid-svg-icons';

// ✅ Add FontAwesome icons to the library globally
library.add(faHeart, faHeartCrack, faVolumeLow);

const PopoutWebPlayer = ({ session, config }) => {
  return (
    <div className="player-wrapper mobile-portrait">
      {/* ✅ Render WebPlayer component for popout with appropriate props */}
      <WebPlayer
        session={session}
        config={config}
        streamUrl={config?.STREAM_URL}
        metadataUrl={config?.METADATA_URL || `/api/contentmanagement/tenants/${config?.tenantId || 'default'}/metadata`}
        showMinimizeButton={false}     // 🚫 No minimize button in popout
        showPopoutButton={false}       // 🚫 No popout button in popout
      />
    </div>
  );
};

export default PopoutWebPlayer;